import React, {FunctionComponent, useReducer} from "react";
import './Wizard.scss';
import WizardReducer, {WizardInitialState} from "../../reducer/wizard";
import WizardStepAdresse from "../wizardStepAdresse/WizardStepAdresse";
import WizardStepKontakt from "../wizardStepKontakt/WizardStepKontakt";
import WizardStepSummary from "../wizardStepSummary/WizardStepSummary";
import WizardStepQuittung from "../wizardStepQuittung/WizardStepQuittung";

const Wizard: FunctionComponent<{}> = () => {
    const [wizard, dispatch] = useReducer(WizardReducer, WizardInitialState)
    return <div className="msc-anmeldung__wizard">
        {wizard.step !== 'quittung' ? <div className="msc-anmeldung__wizard-progress">
            <div className={`msc-anmeldung__wizard-progress-step ${
                wizard.step === 'adresse' ? 'msc-anmeldung__wizard-progress-step-active' : ''
            } ${
                wizard.abonierenState === "aboniere" ? 'msc-anmeldung__wizard-progress-step-deaktiviert' : ''
            }`} onClick={() => {
                if (wizard.abonierenState !== "aboniere")
                    dispatch({
                        type: 'SET_STEP',
                        value: 'adresse'
                    })
            }}>Adresssuche</div>
            <div></div>
            <div className={`msc-anmeldung__wizard-progress-step ${
                wizard.step === 'kontakt' ? 'msc-anmeldung__wizard-progress-step-active' : ''
            } ${
                wizard.ausgewaehlteAdresse === null || wizard.abonierenState === "aboniere" ? 'msc-anmeldung__wizard-progress-step-deaktiviert' : ''
            }`} onClick={() => {
                if (wizard.ausgewaehlteAdresse !== null && wizard.abonierenState !== "aboniere")
                    dispatch({
                        type: 'SET_STEP',
                        value: 'kontakt'
                    })
            }}>Kontaktangabe</div>
            <div></div>
            <div className={`msc-anmeldung__wizard-progress-step ${
                wizard.step === 'summary' ? 'msc-anmeldung__wizard-progress-step-active' : ''
            } ${
                wizard.ausgewaehlteAdresse === null || !wizard.kontakt.valide || wizard.abonierenState === "aboniere" ? 'msc-anmeldung__wizard-progress-step-deaktiviert' : ''
                
            }`} onClick={() => {
                if (wizard.ausgewaehlteAdresse !== null && wizard.kontakt.valide && wizard.abonierenState !== "aboniere")
                    dispatch({
                        type: 'SET_STEP',
                        value: 'summary'
                    })
            }}>Zusammenfassung</div>
        </div> : <></>}
        <div className="msc-anmeldung__wizard-steps">
            {wizard.step === 'adresse' ? <WizardStepAdresse state={wizard} dispatch={dispatch} /> : <></>}
            {wizard.step === 'kontakt' ? <WizardStepKontakt state={wizard} dispatch={dispatch} /> : <></>}
            {wizard.step === 'summary' ? <WizardStepSummary state={wizard} dispatch={dispatch} /> : <></>}
            {wizard.step === 'quittung' ? <WizardStepQuittung state={wizard} dispatch={dispatch} /> : <></>}
        </div>
    </div>
};

export default Wizard
